<script>
  export default {
    props: {
      tipo: {
        type: String,
        default: 'primary'
      },
      texto: {
        type: String,
        required: true,
      },
      icone: {
        type: String,
      }
    },
    methods: {
      telaCheia() {
        if (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled) {
          const element = document.getElementById("relatorio").getElementsByClassName('ibox-content')[0];

          if ("requestFullscreen" in element) {
            element.requestFullscreen();

            document.addEventListener("fullscreenchange", () => {
              document.fullscreen ? this.esconderElementosParaTelaCheia() : this.mostrarElementosAoSairDaTelaCheia();
            }, false);
          }
          else if ("webkitRequestFullscreen" in element) {
            element.webkitRequestFullscreen();

            document.addEventListener("webkitfullscreenchange", () => {
              document.webkitIsFullScreen ? this.esconderElementosParaTelaCheia() : this.mostrarElementosAoSairDaTelaCheia();
            }, false);
          }
          else if ("mozRequestFullScreen" in element) {
            element.mozRequestFullScreen();

            document.addEventListener("mozfullscreenchange", () => {
              document.mozFullScreen ? this.esconderElementosParaTelaCheia() : this.mostrarElementosAoSairDaTelaCheia();
            }, false);
          }
          else if ("msRequestFullscreen" in element) {
            element.msRequestFullscreen();

            document.addEventListener("msfullscreenchange MSFullscreenChange", () => {
              document.msFullscreenElement ? this.esconderElementosParaTelaCheia() : this.mostrarElementosAoSairDaTelaCheia();
            }, false);
          }
        }
      },
      esconderElementosParaTelaCheia() {
        document.getElementById('page-wrapper')
          .getElementsByClassName('footer')[0]
          .style
          .visibility = 'hidden';

        document.getElementById('page-wrapper')
          .getElementsByClassName('navbar')[0]
          .style
          .visibility = 'hidden';

        document.getElementById('wrapper')
          .getElementsByClassName('navbar-default')[0]
          .style
          .visibility = 'hidden';

        document.getElementById("relatorio")
          .getElementsByClassName('ibox-content')[0]
          .style
          .overflow = 'auto';
      },
      mostrarElementosAoSairDaTelaCheia() {
        document.getElementById('page-wrapper')
          .getElementsByClassName('footer')[0]
          .style
          .visibility = 'visible';

        document.getElementById('page-wrapper')
          .getElementsByClassName('navbar')[0]
          .style
          .visibility = 'visible';

        document.getElementById('wrapper')
          .getElementsByClassName('navbar-default')[0]
          .style
          .visibility = 'visible';

        document.getElementById("relatorio")
          .getElementsByClassName('ibox-content')[0]
          .style
          .overflow = '';
      }
    }
  }
</script>

<template>
    <button
      :class="['btn btn-' + tipo]"
      @click="telaCheia"
      type="button">
      <i :class="['fa fa-'+ icone]" v-if="icone"></i> {{ texto }}
    </button>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/TelaCheia.vue